module.exports = __webpack_public_path__ + "img/kebijakan-permen.dd1669ec.svg";